import { render, staticRenderFns } from "./producer-modify.vue?vue&type=template&id=7cfbc556&scoped=true"
import script from "./producer-modify.vue?vue&type=script&lang=js"
export * from "./producer-modify.vue?vue&type=script&lang=js"
import style0 from "./producer-modify.vue?vue&type=style&index=0&id=7cfbc556&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfbc556",
  null
  
)

export default component.exports